// import { fetchCart } from 'theme';

// cart drawer A/B test page activation
// pages listed here are activated/deactivated each time the cart drawer opens/reloads based on cart state

//Requirements:
// in theme settings need to activate Cart drawer experiments setting
// in Ablyft need to create/add pages with matching API names from cartDrawerPages list

const cartDrawerPages = [
	{
		pageApiName: 'cart-drawer-with-items-relaunch',
		pageId: 11367771,
		// shouldActivate: async () => {
		// 	const cart = await fetchCart;
		// 	return cart?.item_count > 0;
		// },

		// FASTER SOLUTION: as we always show upsell (cross-sell) in cart-drawer,
		// check via product-recommendations el cause it's only rendered when cart has items
		shouldActivate: () => !!document.querySelector('cart-drawer product-recommendations'),
	},
];

function isPageActive(pageId) {
	if (!window['ablyft']?.get) return false;
	return window['ablyft'].get('activePageIds')?.includes(pageId) ?? false;
}

function activateCartDrawerPages() {
	if (!window['ablyft']) return;

	cartDrawerPages.forEach(({ pageApiName, pageId, shouldActivate }) => {
		const activate = shouldActivate();
		const alreadyActive = isPageActive(pageId);

		if (activate && !alreadyActive) {
			window['ablyft'].push({
				eventType: 'activatePage',
				pageApiName,
			});
		} else if (!activate && alreadyActive) {
			window['ablyft'].push({
				eventType: 'deactivatePage',
				pageApiName,
			});
		}
	});
}

const cartDrawer = document.querySelector('cart-drawer');
// dialog:after-show - cart drawer open
// cart-drawer:refreshed - cart updated when drawer is open (item added/removed)
cartDrawer?.addEventListener('dialog:after-show', activateCartDrawerPages);
cartDrawer?.addEventListener('cart-drawer:refreshed', activateCartDrawerPages);
